import type { Plugin } from 'vue';
import {
  ModuleRegistry,
  ValidationModule,
  CellStyleModule,
  RenderApiModule,
  PinnedRowModule,
  RowStyleModule,
} from 'ag-grid-community';
import {
  ServerSideRowModelModule,
  ServerSideRowModelApiModule,
  LicenseManager,
  RowGroupingModule,
} from 'ag-grid-enterprise';

export const agGridPlugin: Plugin = {
  install() {
    ModuleRegistry.registerModules([
      ...(import.meta.env.DEV || import.meta.env.VITE_STAGE === 'dev' || import.meta.env.VITE_STAGE === 'uat'
        ? [ValidationModule]
        : []),
      ServerSideRowModelModule,
      ServerSideRowModelApiModule,
      RowGroupingModule,
      CellStyleModule,
      RenderApiModule,
      PinnedRowModule,
      RowStyleModule,
    ]);

    LicenseManager.setLicenseKey(import.meta.env.VITE_AG_GRID_LICENSE_KEY);
  },
};
